import type { List } from '@/types/common';
import type {
	EventSearchQuery,
	SearchedEventDetail,
	FeaturedEventQuery,
} from '@/types/search';

export const getSearchEventsAPI = (query: EventSearchQuery) => {
	return useRequest<List<SearchedEventDetail>>(
		EVENTS_SEARCH_ENDPOINT,
		REQUEST_METHOD.GET,
		{},
		query,
	);
};

export const getFeaturedEventsAPI = (query: FeaturedEventQuery) => {
	return useRequest<List<SearchedEventDetail>>(
		EVENTS_FEATURED_LIST_ENDPOINT,
		REQUEST_METHOD.GET,
		{},
		query,
	);
};